module.exports = __webpack_public_path__ + "public/img/join-lose.a051ed60.png";